import { render, staticRenderFns } from "./WeightsSetEditor.vue?vue&type=template&id=c8492b36&scoped=true"
import script from "./WeightsSetEditor.vue?vue&type=script&lang=ts"
export * from "./WeightsSetEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8492b36",
  null
  
)

export default component.exports